import type { OrganizationInfo } from './apiClients/TokenClient';

export type SubscriptionOrganization = Pick<
    OrganizationInfo,
    'IsSubscriptionActive' | 'SubscriptionNotRequired'
>;

export const hasSubscriptionAccess = (organization?: SubscriptionOrganization): boolean =>
    organization?.SubscriptionNotRequired === true || organization?.IsSubscriptionActive === true;

export const requiresSubscription = (organization?: SubscriptionOrganization): boolean =>
    organization !== undefined && organization.SubscriptionNotRequired !== true;
